/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Shared by every cart write below. /cart/update.js applies a whole body —
   * a map of line keys (or variant ids) to quantities, cart attributes, or
   * both — in one request, which is what keeps each of these operations
   * atomic. */
  function postCartUpdate(body) {
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';

    return fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed (' + response.status + ')');
      return response.json();
    });
  }

  /* The other half of the pair: an honest add, the same call the shop's own
   * add-to-cart buttons make. Resolves with the added line, whose `key` and
   * `quantity` are what the caller needs to put the cart back. */
  function postCartAdd(body) {
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';

    return fetch(cartUrl + '/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (response) {
      // Shopify puts the human-readable reason in the body on a 422 (a
      // quantity rule, an inventory limit, an app blocking the add), so read
      // it rather than reporting a bare status code.
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(
            'Cart add failed (' + response.status + '): ' +
              ((data && (data.description || data.message)) || 'no reason given')
          );
        }
        return data;
      });
    });
  }

  /* Liquid writes these as trailing-comma lists ("k1,k2,"). */
  function parseLineKeys(value) {
    return (value || '').split(',').filter(Boolean);
  }

  /* Set each listed line to a quantity, one line at a time, by key.
   *
   * NOT /cart/update.js, even though that would be one request: when it
   * can't find a key it falls back to reading it as a VARIANT id and applies
   * the quantity to every line of that variant. A key that went stale between
   * render and request — a second tab, a second run, an app's own write —
   * would then wipe the nested STO lines of the same variant. Tested against
   * the store. /cart/change.js answers an unknown key with a 400 and changes
   * nothing, so a line that's already gone is simply skipped. */
  function setLineQuantities(keys, quantity) {
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';

    return keys.reduce(function (previous, key) {
      return previous.then(function () {
        return fetch(cartUrl + '/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({id: key, quantity: quantity})
        }).then(function (response) {
          if (!response.ok && response.status !== 400) {
            throw new Error('Cart change failed (' + response.status + ')');
          }
        });
      });
    }, Promise.resolve());
  }

  /* ---------------------------------------------------------------------
   * In-cart STO swapping
   *
   * The configurator (quiz) adds a device plus one $0 "STO Selection" line
   * per STO the customer chose. The device product fixes how many STOs the
   * order must contain ("... - 3 STO"), so the cart offers a swap control on
   * those lines instead of quantity/remove — see snippets/sto-swap.liquid.
   *
   * Each STO line is nested under its device (see "Nesting STOs under their
   * device" below), and Shopify won't move an existing line to a different
   * variant or parent, so a swap is two requests: add the new STO under the
   * same device, then remove the old one. Add first, so a failure in between
   * leaves one STO too many rather than one too few — the render after the
   * reload sees the device over its count and trimStoOvercount() removes the
   * newest line, which undoes the swap cleanly.
   *
   * On success the page reloads. The theme re-renders the cart from its own
   * `api-cart-items` section and re-binds handlers as part of that; calling
   * those internals from here would couple this to Palo Alto's private API
   * and break on a theme update. A reload is slower but stays correct.
   * ------------------------------------------------------------------- */
  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest && event.target.closest('[data-sto-swap]');
    if (!select) return;

    var fromVariant = select.getAttribute('data-sto-current');
    var fromKey = select.getAttribute('data-sto-line-key');
    var parentKey = select.getAttribute('data-sto-parent-key');
    var toVariant = select.value;
    if (!fromVariant || !fromKey || !parentKey || !toVariant || fromVariant === toVariant) return;

    select.disabled = true;

    postCartAdd({items: [{id: Number(toVariant), quantity: 1, parent_line_key: parentKey}]})
      .then(function () {
        return setLineQuantities([fromKey], 0).catch(function (error) {
          // Reload regardless — the overcount repair takes it from here.
          console.error('[STO swap] old STO not removed:', error);
        });
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        // The add failed, so nothing changed. Put the control back where it
        // was so the dropdown never claims a selection the cart doesn't hold.
        console.error('[STO swap]', error);
        select.value = fromVariant;
        select.disabled = false;
      });
  });


  /* ---------------------------------------------------------------------
   * Nesting STOs under their device
   *
   * The STO lines are $0 companions to the device and have no remove control
   * of their own. As nested cart lines (Shopify's parent_line_key), they
   * leave with their device on every removal path — the remove link, the
   * quantity stepper, a second tab, an app — with nothing here having to
   * intercept anything, and they stay with the RIGHT device when a second
   * one is in the cart, which no theme-side guess could manage.
   *
   * The configurator hands off with a cart permalink, which can't create
   * nested lines, so its STOs arrive loose. On the first render Liquid
   * identifies the one device they belong to and this re-adds them nested
   * under it, then removes the loose copies. Add first, for the same reason
   * as the swap: if the removal fails, the loose copies are now duplicates of
   * nested lines and the orphan check clears them on the next render.
   *
   * It has to be safe to run twice. A hand-off through the myshopify.com
   * domain renders the cart once there and again on the primary domain
   * after the redirect — two pages, each with its own latch — and a
   * customer can have two tabs open. So the loose lines are read from
   * cart.js at the moment of acting rather than from the rendered marker,
   * and a run that finds nothing loose does nothing. Two runs that overlap
   * exactly can still both add, which merges into quantity 2;
   * resetStoQuantities() puts that back to 1.
   *
   * Loose STOs that can't be adopted — the device went before they were
   * nested, or there's no telling which device they came with — are orphans,
   * and clearOrphanedStoLines() removes them.
   * ------------------------------------------------------------------- */

  /* Shared by every write that fires off a cart render, so two of them can't
   * race each other on the same page. */
  var cartWriteInFlight = false;

  /* Adoption retries on a later page load, not on every DOM mutation: a
   * request that failed once (an app rejecting the add, say) would fail the
   * same way again, and the MutationObserver below fires constantly. */
  var adoptionAttempted = false;

  function adoptLooseStoLines() {
    if (cartWriteInFlight || adoptionAttempted) return;

    var marker = document.querySelector('[data-sto-adopt]');
    if (!marker) return;

    var parentKey = marker.getAttribute('data-sto-adopt');
    var stoHandle = marker.getAttribute('data-sto-handle');
    if (!parentKey || !stoHandle) return;

    adoptionAttempted = true;
    cartWriteInFlight = true;

    var looseKeys = [];

    getCart()
      .then(function (cart) {
        var parentStillThere = cart.items.some(function (item) {
          return item.key === parentKey;
        });
        var loose = cart.items.filter(function (item) {
          return item.handle === stoHandle && !item.parent_relationship;
        });
        // Already adopted (by another page) or the device has gone: nothing
        // to do here, and the next render shows whichever it was.
        if (!parentStillThere || !loose.length) return false;

        looseKeys = loose.map(function (item) {
          return item.key;
        });

        return postCartAdd({
          items: loose.map(function (item) {
            return {id: item.variant_id, quantity: 1, parent_line_key: parentKey};
          })
        }).then(function () {
          return setLineQuantities(looseKeys, 0);
        }).then(function () {
          return true;
        });
      })
      .then(function (changed) {
        if (changed) {
          window.location.reload();
        } else {
          cartWriteInFlight = false;
        }
      })
      .catch(function (error) {
        console.error('[STO adopt]', error);
        cartWriteInFlight = false;
      });
  }

  /* Zero every line key listed on a Liquid marker, then reload. */
  function zeroMarkedLines(attribute, label) {
    if (cartWriteInFlight) return;

    var marker = document.querySelector('[' + attribute + ']');
    if (!marker) return;

    var keys = parseLineKeys(marker.getAttribute(attribute));
    if (!keys.length) return;

    cartWriteInFlight = true;

    setLineQuantities(keys, 0)
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        // Leave the lines visible rather than retrying in a loop; the next
        // render gets another chance.
        console.error('[' + label + ']', error);
        cartWriteInFlight = false;
      });
  }

  function clearOrphanedStoLines() {
    zeroMarkedLines('data-sto-orphans', 'STO orphans');
  }

  /* More STOs nested under a device than it allows: a swap that added its
   * new STO and never removed the old one. Liquid lists the newest extras. */
  function trimStoOvercount() {
    zeroMarkedLines('data-sto-overcount', 'STO overcount');
  }

  /* An STO line above quantity 1 is always wrong — those lines have no
   * quantity control. Two things can produce it: the nudge below failing
   * after its add but before its restore (a customer who closed the tab in
   * that window and came back), and two adoption runs overlapping exactly. */
  function resetStoQuantities() {
    if (cartWriteInFlight) return;

    var marker = document.querySelector('[data-sto-overquantity]');
    if (!marker) return;

    var keys = parseLineKeys(marker.getAttribute('data-sto-overquantity'));
    if (!keys.length) return;

    cartWriteInFlight = true;

    setLineQuantities(keys, 1)
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        console.error('[STO quantity]', error);
        cartWriteInFlight = false;
      });
  }

  /* ---------------------------------------------------------------------
   * Announcing a configurator cart
   *
   * The configurator hands off with a cart permalink, which Shopify builds
   * server-side before the cart page renders. No /cart/add.js, no form post,
   * no cart-change event — so the app that applies the 3+ STO promotion (EG
   * Auto Add to Cart) has nothing to react to and the gift never lands.
   *
   * EG watches for cart writes by replacing window.fetch and
   * XMLHttpRequest.prototype.send, matching any POST whose URL contains
   * "/cart/add", "/cart/update", "/cart/change" or "/cart/clear". So the
   * nudge is simply a cart write it can see: add a second unit of an STO the
   * cart already has, then put it straight back to one. The add is a plain
   * /cart/add.js, the same call the shop's own add-to-cart button makes.
   *
   * TIMING IS THE WHOLE TRICK. EG's script is loaded `async` from a
   * third-party CDN; this file is `defer`, so it runs at DOMContentLoaded —
   * reliably BEFORE EG has replaced window.fetch. Firing the nudge then sends
   * it down the untouched native fetch, where EG never sees it, which is why
   * an in-cart STO swap (a human click, seconds later) set the promotion off
   * and this did not. So wait for the interceptor to actually be in place.
   *
   * Bumping an existing line rather than removing and re-adding one is
   * deliberate: nothing is ever taken away, so a failure part-way through
   * can't strand a cart without its STO selections. The one state it can
   * leave — a line stuck at quantity 2, which is also what happens if EG
   * reloads the page in response — resetStoQuantities() repairs.
   *
   * Deliberately no reload here. The cart ends up in the state already on
   * screen, and reloading would race whatever EG is doing.
   * ------------------------------------------------------------------- */

  /* Has something replaced window.fetch yet? EG sets EasyGiftScriptLoaded
   * partway through its startup and patches fetch a good deal later, and
   * other apps on this store patch fetch too — so neither signal is
   * conclusive on its own and both together are only a hint. Treat this as
   * "probably ready" and let the verify-and-retry below carry the weight. */
  function cartInterceptorReady() {
    try {
      if (window.EasyGiftScriptLoaded !== true) return false;
      return !/\{\s*\[native code\]\s*\}/.test(
        Function.prototype.toString.call(window.fetch)
      );
    } catch (error) {
      // Can't tell — don't block on it.
      return true;
    }
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function pageLoaded() {
    if (document.readyState === 'complete') return Promise.resolve();
    return new Promise(function (resolve) {
      window.addEventListener('load', function () {
        resolve();
      });
    });
  }

  function whenCartInterceptorReady() {
    // This file is `defer` and EG is a third-party `async`, so at
    // DOMContentLoaded EG has reliably NOT patched fetch yet. Wait for the
    // load event first, then for the hint above, then let it settle. If EG is
    // blocked or missing, give up waiting after ten seconds and go anyway:
    // the nudge is harmless on its own and the guard still needs writing.
    return pageLoaded().then(function () {
      var deadline = Date.now() + 10000;

      return (function poll() {
        if (cartInterceptorReady() || Date.now() > deadline) return wait(1500);
        return wait(100).then(poll);
      })();
    });
  }

  function getCart() {
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
    // A GET of cart.js is not something EG intercepts, so this observes
    // without disturbing anything.
    return fetch(cartUrl + '.js', {headers: {Accept: 'application/json'}})
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read the cart');
        return response.json();
      });
  }

  function findStoLine(cart, handle) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === handle) return cart.items[i];
    }
    return null;
  }

  /* ---------------------------------------------------------------------
   * Announcing a configurator cart
   *
   * The configurator hands off with a cart permalink, which Shopify builds
   * server-side before the cart page renders. No /cart/add.js, no form post,
   * no cart-change event — so the app that applies the 3+ STO promotion (EG
   * Auto Add to Cart) has nothing to react to and the gift never lands.
   *
   * EG watches for cart writes by replacing window.fetch and
   * XMLHttpRequest.prototype.send, matching any POST whose URL contains
   * "/cart/add", "/cart/update", "/cart/change" or "/cart/clear". So the
   * nudge is a cart write it can see: add a second unit of an STO the cart
   * already has, then put it straight back to one.
   *
   * The STO line comes out of cart.js rather than out of the Liquid marker,
   * so variant_id is posted as a NUMBER — the marker could only give a
   * string, and the shop's own add-to-cart button sends a number. Running
   * this sequence by hand with the numeric id on a settled page does add the
   * gift, and staying identical to the thing that demonstrably works is
   * worth one extra GET.
   *
   * Nothing EG exposes says "my interceptor is installed", and this file
   * runs `defer` while EG is a third-party `async`, so at DOMContentLoaded
   * it reliably is not. Rather than keep guessing at a readiness signal, do
   * the nudge, then check whether the cart actually grew, and try once more
   * if it didn't. Two rounds, then stop either way.
   *
   * Bumping an existing line rather than removing and re-adding one is
   * deliberate: nothing is ever taken away, so a failure part-way through
   * can't strand a cart without its STO selections. The one state it can
   * leave — a line stuck at quantity 2 — resetStoQuantities() repairs.
   * ------------------------------------------------------------------- */
  var configuratorAnnounced = false;

  /* One bump-and-restore. The guard attribute rides along on the restore
   * rather than going out on its own: EG special-cases a /cart/update.js
   * whose payload has no `updates` field, holding it for two seconds and
   * passing it through with no rules applied. */
  function nudgeCartOnce(stoLine) {
    var add = {id: stoLine.variant_id, quantity: 1};
    // The line is nested under its device. Naming the same parent is what
    // makes the add merge into it; without it Shopify makes a new loose line.
    if (stoLine.parent_relationship) {
      add.parent_line_key = stoLine.parent_relationship.parent_key;
    }

    return postCartAdd(add).then(function (data) {
      // /cart/add.js answers with the added line, but the shape has moved
      // around across API versions — sometimes the line itself, sometimes
      // {items: [line]}. Take whichever this is, and fall back to the line we
      // started from if neither carries a key.
      var line = (data && data.items && data.items[0]) || data || {};
      var updates = {};
      // Normally the add merges into the existing line and this is 1. If it
      // somehow made a line of its own it is 0, which removes it.
      updates[line.key || stoLine.key] =
        typeof line.quantity === 'number' ? line.quantity - 1 : 1;

      // EG clears its in-flight state 200ms after a response before it will
      // treat the next request as fresh. Let that land, so the restore can't
      // be folded into the add it is undoing. Only the STO line is listed, so
      // a gift added meanwhile is left alone.
      return wait(400).then(function () {
        return postCartUpdate({updates: updates, attributes: {configurator: '1'}});
      });
    });
  }

  function announceConfiguratorCart() {
    if (cartWriteInFlight || configuratorAnnounced) return;

    var marker = document.querySelector('[data-configurator-announce]');
    if (!marker) return;

    var stoHandle = marker.getAttribute('data-sto-handle');
    if (!stoHandle) return;

    /* A short-lived loop breaker, nothing more. The real guard is the
     * `configurator` cart attribute: Liquid stops rendering the marker once
     * it is set, and a new hand-off clears it because a cart permalink
     * replaces the cart's attributes along with its contents. This only has
     * to cover the gap before that attribute is written — a reload in the
     * middle of the sequence, whether ours or one EG performs itself.
     *
     * Hence a timestamp rather than an identifier. Keying it on the cart's
     * contents does not work: a Shopify line key is the variant id plus a
     * hash of the line's properties, so an STO line with no properties has
     * the SAME key in every cart, and latching on it silently skipped every
     * configurator cart after the first in a browser session. */
    var STORAGE_KEY = 'tetra:configurator-nudged-at';
    var LOOP_WINDOW = 30000;
    try {
      var last = parseInt(window.sessionStorage.getItem(STORAGE_KEY), 10);
      if (last && Date.now() - last < LOOP_WINDOW) return;
      window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (error) {
      // Private mode or storage disabled: the other guards still apply.
    }

    configuratorAnnounced = true;
    var itemsBefore = 0;
    var stoLine = null;

    whenCartInterceptorReady()
      .then(function () {
        cartWriteInFlight = true;
        return getCart();
      })
      .then(function (cart) {
        itemsBefore = cart.items.length;
        stoLine = findStoLine(cart, stoHandle);
        if (!stoLine) throw new Error('No ' + stoHandle + ' line to nudge with');
        return nudgeCartOnce(stoLine);
      })
      // EG holds its own writes for two seconds before applying them.
      .then(function () {
        return wait(2500);
      })
      .then(getCart)
      .then(function (cart) {
        // A new line means a gift landed and there is nothing more to do.
        if (cart.items.length > itemsBefore) return null;
        // Otherwise the first round most likely went out before EG was
        // listening. It is settled by now, so one more try is worth it — and
        // a second round is harmless if the rule simply doesn't apply here.
        return wait(1000)
          .then(function () {
            return nudgeCartOnce(stoLine);
          })
          .then(function () {
            return wait(2500);
          });
      })
      .then(function () {
        cartWriteInFlight = false;
        /* Reload. EG applies its changes server-side, so a gift it added is
         * not on screen until something re-renders — the in-cart STO swap
         * that fires the promotion successfully reloads afterwards, and that
         * reload is the only reason its result is visible. */
        window.location.reload();
      })
      .catch(function (error) {
        // resetStoQuantities() repairs a line left at quantity 2.
        console.error('[configurator cart] nudge failed:', error);
        cartWriteInFlight = false;
      });
  }

  function onCartRendered() {
    // Orphans first: clearing them removes the STO lines that make this a
    // configurator cart, and there's no point announcing one that is about to
    // stop being one. Then nest any loose STOs under their device, and repair
    // counts and quantities, so the nudge borrows a nested line that is
    // already at 1. Each of these reloads or latches, so only one runs.
    clearOrphanedStoLines();
    adoptLooseStoLines();
    trimStoOvercount();
    resetStoQuantities();
    announceConfiguratorCart();
  }

  onCartRendered();
  // The drawer renders after page load, and the cart page re-renders itself
  // in place after any AJAX update — neither fires a load event, and the
  // theme's only cart hook is drawer-specific.
  document.addEventListener('theme:cart:loaded', onCartRendered);

  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // Coalesce a re-render's many mutations into one check.
      window.setTimeout(function () {
        pending = false;
        onCartRendered();
      }, 0);
    }).observe(document.body, {childList: true, subtree: true});
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
